import { ERROR, WARNING } from './error-handler.actions';

export const errorEventDefinitions = {
  [ERROR]: {
    eventFields: (state, action) => ({
      exDescription: action.payload.message,
      exFatal: true,
      name: action.payload.name
    }),
  },
  [WARNING]: {
    eventFields: (state, action) => ({
      exDescription: action.payload.message,
      exFatal: false,
      name: action.payload.name
    }),
  },
};
